/**
 * FamilySharingPreview · Milestone 1 tone-validation surface.
 *
 * Per GOV-DASH-001 §5 (preview-first before in-place mount into the
 * frozen dashboard) and IMPL-FAMILY-SHARING-PLAN §Milestone 1: the
 * FTUE surface is delivered here at `#family-sharing-preview` so the
 * Product Office can validate the tone before authorising its mount
 * inside `CruiseHome.jsx` (currently under GOV-DASH-001 Protected
 * Maintenance).
 *
 * This route is NOT linked from the sidebar. It is reached only by
 * explicit URL. The preview page renders a minimal editorial hero
 * placeholder above the panel so reviewers see the FTUE in the same
 * visual context in which it will eventually live.
 */
import React from "react";
import FamilySharingPanel from "@/components/family-sharing/FamilySharingPanel";

export default function FamilySharingPreview() {
  return (
    <div
      data-testid="cc-family-sharing-preview-page"
      className="max-w-[1100px] mx-auto px-6 py-8 space-y-6"
    >
      <header className="space-y-2">
        <div className="cc-overline text-[#1e6de5]">
          IMPL-FAMILY-SHARING · Milestone 1 · FTUE Preview
        </div>
        <h1 className="font-display font-bold text-[#0F172A] text-[28px] leading-tight">
          Tone validation preview
        </h1>
        <p className="text-[13.5px] text-[#475569] max-w-2xl leading-relaxed">
          This is where the Family Sharing panel will live on Cruise Home,
          below the editorial hero, once the Product Office authorises the
          in-place mount under GOV-DASH-001 §5.
        </p>
      </header>

      <HeroPlaceholder />
      <FamilySharingPanel />
    </div>
  );
}

function HeroPlaceholder() {
  return (
    <section
      aria-hidden="true"
      className="rounded-2xl overflow-hidden relative"
      style={{
        height: 200,
        background:
          "linear-gradient(135deg, rgba(15,23,42,0.9) 0%, rgba(30,109,229,0.55) 100%)",
      }}
    >
      <div className="absolute inset-0 flex items-end px-6 pb-5">
        <div className="text-white space-y-1">
          <div className="text-[10.5px] font-black tracking-[0.22em] uppercase opacity-80">
            Cruise Home — editorial hero (placeholder)
          </div>
          <div className="font-display font-bold text-[22px] leading-tight">
            Symphony of the Seas
          </div>
          <div className="text-[12px] opacity-90">Oct 25 — Nov 1</div>
        </div>
      </div>
    </section>
  );
}
